import{findDOMNode}from"react-dom";var findNodeHandle=component=>{var node;try{node=findDOMNode(component)}catch(e){}return node};export default findNodeHandle;